import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as featureClassActions from './../../../actions/featureClassActions';

import FeatureClassList from './FeatureClassList';
import FeatureClassForm from './FeatureClassForm';


class FeatureClassHome extends React.Component {

   componentDidMount() {
      this.props.actions.loadAllFeatureClasses();
   }

   saveNewFeatureClass = (featureClass) => {
      return this.props.actions.saveNewFeatureClass(featureClass);
   };

   render() {
      const { featureClasses } = this.props;
      return (
         <div>
            <FeatureClassList featureClasses={featureClasses} />
            <FeatureClassForm saveNewFeatureClass={this.saveNewFeatureClass} />
         </div>
      );
   }
}

FeatureClassHome.propTypes = {
   handleSubmit: React.PropTypes.func.isRequired,
   saveNewFeatureClass: React.PropTypes.func,
   actions: React.PropTypes.object,
   featureClasses: React.PropTypes.array
};

function mapStateToProps(state) {
   return {
      featureClasses: state.featureClasses
   };
}
function mapDispatchToProps(dispatch) {
   return {
      actions: bindActionCreators(featureClassActions, dispatch)
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(FeatureClassHome);



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/FeatureClass/FeatureClassHome.js
 **/